import api from "./api";

export default {
  index(model, pagination = false, page = 1, limit = 100, search=false){
    return api.get(`${model}`, {
      params:{pagination:pagination,page:page, limit: limit, search}});
  },
  whatsappAccounts(){
    return api.get('whatsapp/accounts');
  },
  templates(phoneNumberId){
    return api.get('templates', {
      params: phoneNumberId ? { phone_number_id: phoneNumberId } : {},
    });
  },
  paginate(model, page = 1, limit = 100, search='', pagination = true){
    return api.get(`${model}`, {
      params:{pagination:pagination,page:page, limit: limit, search}});
  },
  create(model, data){
    return api.post(`${model}`, data);
  },
  update(model, id,data){
    return api.patch(`${model}/${id}`, data);
  },

  show(model, id, page = 1, limit = 8){
    return api.get(`${model}/${id}`, {
      params:{page:page, limit: limit}
    });
  },

  
  destroy(model,id){
    return api.delete(`${model}/${id}`);
  },
  postWithConfig(model, data, config){
    return api.post(`${model}`, data, config);
  },

  addedFrom(from){
    return api.get(`users/from/${from}`);
  },
  campaigns(campaign){
    return api.get(`users/campaigns/${campaign}`);
  },
  campaignsFilter(filter){
    return api.post('users/campaigns/filter', filter);
  },

  hideUnhideFrom(action, from){
    return api.get(`users/${action}/${from}`);
  },

  export(filter){
    const query = filter ? `?addedFrom=${filter}` : '';
    return api.get(`users/export${query}`,
      {
        responseType: 'blob' // <-- REQUIRED for file downloads
      }
    );
  },
};
